import React, { Fragment } from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import SelectField from "Components/formControls/HookFields/SelectField";
import PasswordComplexityMessage from "./PasswordComplexityMessage";

// import useStyles from "../../styles";
// import { useTargetValidation } from "Validations/target/useTargetValidation";
// import { CompanyDetails } from "Recoil/LoggedInUserDetail/selector";
// import { useRecoilValue } from "recoil";
// import { useCheckinConstant } from "Hooks/checkin/useCheckinConstant";
// import { Grid } from "@material-ui/core";
import { useOrganizationConstants } from "Hooks/organization/useOrganizationConstants";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
// import { useRecoilValue, useSetRecoilState } from "recoil";
// import { instructionField } from "Recoil/CompanySetup/selector";
// import { instructionKeys } from "src/constants/instructionKeys";

const PasswordComplexity = () => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
    watch
  } = useFormContext();
  const { organizationPasswordComplexityError } = useOrganizationValidation();
  const { passwordComplexityOptions } = useOrganizationConstants();
  const { passwordComplexity } = useWatch({ name: `configuration` });
  const { disabledView } = watch();

  return (
    <Fragment>
      <Controller
        register={register(
          `configuration.passwordComplexity`,
          organizationPasswordComplexityError
        )}
        name={`configuration.passwordComplexity`}
        control={control}
        render={({ field }) => {
          const { onChange } = field;
          return (
            <SelectField
              label={t("companySetup.config.passwordComplexity.label")}
              placeholder={t(
                "companySetup.config.passwordComplexity.placeholder"
              )}
              options={passwordComplexityOptions()}
              onChange={onChange}
              value={passwordComplexity}
              error={get(
                errors,
                `configuration.passwordComplexity.message`,
                ""
              )}
              disabled={disabledView}
            />
          );
        }}
      />
      <PasswordComplexityMessage />
    </Fragment>
  );
};

export default PasswordComplexity;
